import { Sound as CommonSound } from "common/sound";
import * as R from "ramda";
export async function loadSound(src) {
    try {
        return await CommonSound.load({
            sheetPath: src,
            sprite: spriteForHowler,
            loopNameMapper,
        });
    }
    catch (e) {
        console.error(e);
        throw e;
    }
}
const loopNameMapper = (loopName) => {
    switch (loopName) {
        case "announceBackground":
            return ["announceBackground"];
        case "buttonEffect":
            return ["buttonEffect"];
    }
};
const sprite = {
    announceOpening: [0, 8 + 2 / 30],
    announceBackground: [8 + 2 / 30, 10 + 26 / 30],
    buttonEffect: [11 + 15 / 30, 12 + 18 / 30],
};
export const spritesDurations = R.map(([start, end]) => end * 1000 - start * 1000, sprite);
const spriteForHowler = R.map(([start, end]) => [
    Math.floor(start * 1000),
    Math.floor(end * 1000 - start * 1000),
], sprite);
//# sourceMappingURL=announceSound.js.map